// OpenBook.jsx
import React from "react";
import styled, { css } from "styled-components";

const Overlay = styled.div`
  position: fixed; /* overlay covers entire screen */
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.6); /* dim background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999; /* make sure it’s on top */
`;

const BookContainerlevelcss = css`
  position:absolute;
  width: 80.5%;
  height: 81vh;
  display: flex;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  overflow: hidden;

`;
const BookContainerlevel1 = styled.div`
 ${BookContainerlevelcss};
  width: 80.5%;
  height: 81vh;
  z-index:2;
  margin-top:0.7vh;


  .level11{
  background:white;
  margin-right:1%;
  }
  .level12{
  background:white;

  }

  @media only screen and (max-width: 700px) {
   .level11{
      display:none;
    } 

}
`;

const BookContainerlevel2 = styled.div`
 ${BookContainerlevelcss};
  width: 81%;
  height: 82vh;
  z-index:1;
  margin-top:1.7vh;

  .level21{
  background:white;
  margin-right:2%;
  }
  .level22{
  background:white;

  }

  @media only screen and (max-width: 700px) {
   .level21{
      display:none;
    } 
`;

const BookContainerCover = styled.div`
 ${BookContainerlevelcss};
  width: 82%;
  height: 84vh;
  z-index:0;
  margin-top:2.5vh;
  border-radius:8px;

  ${props => props.cover ? `
    background: ${props.cover};
  `:
    `background: #87ceeb;`

  }
`;



const BookContainer = styled.div`
  width: 80%;
  height: 80vh;
  display: flex;
  background: #fdfcf7;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  z-index: 999; /* make sure it’s on top */

  @media only screen and (max-width: 700px) {
  
  .mobilespecs{
  display:none;
  }
}
`;

// center "spine"
const Spine = styled.div`
  width: 4px;
  background: linear-gradient(to bottom, #aaa, #444);
  margin: 0 2px;
`;

const Page = styled.div`
  flex: 1;
  padding: 2rem;
  overflow-y: auto;
  font-family: "Georgia", serif;

  &:first-child {
    border-right: 2px dashed #ddd;
  }
`;

const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: 1rem;
`;

const Description = styled.p`
  margin-top:30px;
  font-size: 1rem;
  line-height: 1.6;
  color: #333;
`;

const Img = styled.img`
  width: 40%;
  border-radius: 8px;
  margin: 1rem 0;
  display:flex;
  justify-self:center;
`;

const Section = styled.div`
  margin-bottom: 1.5rem;

`;

const SinglePageSection = styled.div`
  margin-bottom: 1.5rem;
  display:none;

.singlePageImage{
width:40ox;
height:40px;
}

@media only screen and (max-width: 700px) {
  display:flex;
  justify-content:space-around;
  align-items:center;
}
`;

const SkillLevel = styled.div`
  background: #eee;
  border-radius: 50px;
  padding: 0.5rem;
  position: relative;
  height: 20px;
  width: 80%;
  margin-top: 0.5rem;

  &::after {
    content: "";
    display: block;
    height: 100%;
    border-radius: 50px;
    background: linear-gradient(90deg, #6a11cb, #2575fc);
    width: ${({ level }) => level}%;
    transition: width 0.5s ease;
  }
`;

const OpenBook = ({ onClose, data }) => {

  const whereLearnedColors = {
    School: '#FFEBEE',
    Internship: '#E3F2FD',
    'Self-learned': '#E8F5E9',
    'Coaching center': '#F3E5F5',
    Certification: '#FFFDE7',
  };

  return (
    <Overlay onClick={onClose}>
      {/* stop propagation so click inside book doesn't close */}
      <BookContainer onClick={(e) => e.stopPropagation()}>
        {/* Left Page */}
        <Page className="mobilespecs">
          <Title>{data?.skill}</Title>
          <Img src={data?.logo} alt={data?.skill} />
          <Description>
            {data?.description}
          </Description>
        </Page>

        <Spine />

        {/* Right Page */}
        <Page>
          <SinglePageSection className="SinglePage">
            <img className="singlePageImage" src={data?.logo} alt="React Logo" />
            <Title className="singlePageTitle">{data?.skill}</Title>
          </SinglePageSection>
          <Section>
            <h2>Where I Learned</h2>
            {data.whereLearned?.map((text, index) => (
              <p
                key={index}
                style={{
                  backgroundColor: whereLearnedColors[text] || '#f0f0f0', // fallback color
                  padding: '6px 12px',
                  borderRadius: '8px',
                  display: 'inline-block',
                  margin: '4px',
                }}
              >
                {text}
              </p>
            ))}
          </Section>

          <Section>
            <h2>Journey</h2>
            {data.journey}
          </Section>

          <Section>
            <h2>My Level</h2>
            <SkillLevel level={data?.percentage} />
            <p style={{ fontStyle: "italic" }}>{data?.level}</p>
          </Section>
        </Page>
      </BookContainer>
      <BookContainerlevel1><Page className="level11"></Page><Page className="level12"></Page></BookContainerlevel1>
      <BookContainerlevel2><Page className="level21"></Page><Page className="level22"></Page></BookContainerlevel2>
      <BookContainerCover cover={data?.background} />


    </Overlay>
  );
};

export default OpenBook;
